/**
 * Gets the raw, unformatted text content of a block's content value.
 *
 * This is useful, for instance, for extracting a block's `title` without any
 * rich text formatting.
 */
export var getTextContent = function (text) {
    var _a;
    if (!text) {
        return '';
    }
    else if (Array.isArray(text)) {
        return ((_a = text === null || text === void 0 ? void 0 : text.reduce(function (prev, current) {
            return prev + (current[0] !== '⁍' && current[0] !== '‣' ? current[0] : '');
        }, '')) !== null && _a !== void 0 ? _a : '');
    }
    else {
        return text;
    }
};
export var getTextContentDate = function (text) {
    var _a;
    var formatOutputDate = function (dateString) {
        var dateObj = new Date(dateString);
        if (isNaN(dateObj.getTime())) {
            return ''; // Return empty string if dateString is not a valid date
        }
        else {
            return "@".concat(dateObj.toLocaleString('en-US', {
                month: 'long'
            }), " ").concat(dateObj.getDate(), ", ").concat(dateObj.getFullYear());
        }
    };
    if (!text) {
        return '';
    }
    else if (Array.isArray(text)) {
        return ((_a = text === null || text === void 0 ? void 0 : text.reduce(function (prev, current) {
            var _a;
            return prev +
                (current[0] !== '⁍' && current[0] !== '‣'
                    ? current[0]
                    : formatOutputDate((_a = current[1][0][1]) === null || _a === void 0 ? void 0 : _a.start_date));
        }, '')) !== null && _a !== void 0 ? _a : '');
    }
    else {
        return text;
    }
};
//# sourceMappingURL=get-text-content.js.map